<template>
    <div class="listUpDown">
        <loading :iscomplete="true" v-if="!firstBlock"></loading>
        <div class="listContent" id="listContent" v-if="firstBlock">
            <mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
                <slot></slot>
                <newslist :listcontent="dataLIst"></newslist>
            </mescroll-vue>
        </div>
    </div>
</template>

<script>
import loading from "./loading.vue"
import newslist from "./newsList"
// 引入mescroll的vue组件
import MescrollVue from 'mescroll.js/mescroll.vue' //上拉加载，下拉刷新

export default {
    props: {
		datalink: {  //是否显示
			type: String,
			default:()=>"", //必须是一个函数
			required: true,   
        },
        currentdisplay:{ //正在显示的位置
            type: Number,
            default:()=>1, //必须是一个函数
            required: false,  //不是必填项                     
        },
        myIndex:{          //我的位置
            type: Number,
            default:()=>1, //必须是一个函数
			required: false,  //不是必填项
        },
        sign:{           //标识是java的接口还是php 默认是php 
            type: String,
			default:()=>"php", //必须是一个函数
			required: false,   
        },
        isrefresh:{           //刷新接口
            type: String,
			default:()=>"", //必须是一个函数
			required: false,   
        },
    },
    components:{
        loading, //加载
        newslist, //列表
        MescrollVue
    },
    data(){
        return{
            dataLIst:[], //表格数据
            mescroll:null, // mescroll实例对象
            mescrollUp: {
                callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
                page: {
                    num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
                    size: 10 // 每页数据的数量
                },
                htmlNodata: '<p class="upwarp-nodata">-- 到底啦 --</p>',
                noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
                toTop: {
                    src: require('../../assets/mescroll/mescroll-totop.png') // 回到顶部按钮的图片路径,支持网络图
                },
                // empty: {
                //     // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
                //     warpId: 'listContent', // 父布局的id;
                //     icon: require('../../assets/mescroll/mescroll-empty.png'), // 图标,支持网络图
                //     tip: '暂无相关数据~', // 提示
                //     // btntext: '去逛逛 >', // 按钮,默认""
                //     // btnClick () { // 点击按钮的回调,默认null
                //     //     alert('点击了按钮,具体逻辑自行实现')
                //     // }
                // },
                auto:false,
                lazyLoad: {
                    use: false // 是否开启懒加载,默认false
                }
            },
            firstBlock:false,
        }
    },
    watch: {
        // 如果 `question` 发生改变，这个函数就会运行
        currentdisplay:{
            handler:function (newData){
                if(!this.firstBlock){
                    if(newData==this.myIndex){
                        if(this.sign=="php"){
                            this.indexListDataObain();
                        }else{
                            this.indexListJava();
                        }
                    }
                }
            },
            immediate: true
        },
        isrefresh:{ //刷接口
            handler:function (){ 
                // var page={
                //     num: 1,
                //     size: 10,
                //     time: null
                // }
                // this.upCallback(page,this.mescroll);
                // console.log('111');


                // if(this.sign=="php"){
                //     this.indexListDataObain();
                // }else{
                //     this.indexListJava();
                // }
            },
        }
    },
    // mounted(){
    //     if(this.isrefresh=="freshCon"){
    //         var page={
    //             num: 1,
    //             size: 10,
    //             time: null
    //         }
    //         var that=this;
    //         window.addEventListener("setItemEvent", function (e) { //刷新接口
    //             if(e.key=="fcousContent"){
    //                 that.upCallback(page,that.mescroll);
    //             }
    //         });
    //     }
    // },
    methods:{
        // 接口 php
		indexListDataObain(){
			this.$http.get(this.datalink+'&pageid=1')
            .then(resp=>{
                if(resp.data.status=='ok'){
                    if(resp.data.sublivesList_arr){
                        this.dataLIst=resp.data.sublivesList_arr.rs_lists;
                    }else{
                        this.dataLIst=resp.data.content.rs_lists;
                    }
                    this.firstBlock=true;
                }
            });
        },
        // 接口数据 java
		indexListJava(){
            // alert(window.localStorage.civilizationId);
			this.$http.get(this.datalink,{
                params:{
                    page:1,
                    rows:10,
                    sortBy:'create_time',
                    desc:true,
                    memberId:window.localStorage.civilizationId
                }
            })
            .then(resp=>{
                if(resp.data.success){
                    if(resp.data.data.items){
                        this.dataLIst=resp.data.data.items;
                    }
                }
                this.firstBlock=true;
            });
        },

        // 上拉加载，下拉刷新
        // mescroll组件初始化的回调,可获取到mescroll对象
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
        upCallback (page, mescroll) {
            console.log(page,mescroll);
            this.page=page;
            this.mescroll=mescroll;
            if(this.sign=="php"){
                this.indexListPhpPage(page,mescroll)
            }else{
                this.indexListJavaPage(page,mescroll);
            }
        },
        // php接口
        indexListPhpPage(page, mescroll){
            var pageNum = page.num; // 页码, 默认从1开始 如何修改从0开始 ?
            this.$http.get(this.datalink+'&pageid='+pageNum) //调接口
            .then(resp=>{
                if(resp.data.status=='ok'){
                    if (page.num === 1) {
                        this.dataLIst = [];
                    }
                    if(resp.data.sublivesList_arr){
                        this.dataLIst=this.dataLIst.concat(resp.data.sublivesList_arr.rs_lists);
                    }else{
                        if(resp.data.content.rs_lists){
                            this.dataLIst=this.dataLIst.concat(resp.data.content.rs_lists);
                        }
                    }
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
                // mescroll.endByPage(resp.data.content.rs_lists.length,resp.data.total);
                // console.log(resp.data);
                this.$nextTick(()=>{
                    if(resp.data.sublivesList_arr){
                        mescroll.endSuccess(resp.data.sublivesList_arr.rs_lists.length);
                    }else{
                        if(resp.data.content.rs_lists){
                            mescroll.endSuccess(resp.data.content.rs_lists.length);
                        }else{
                            mescroll.endSuccess(0);
                        }
                    }
                })
            }).catch(()=>{
                // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                mescroll.endErr()
            });
        },
        // 接口数据 java
		indexListJavaPage(page,mescroll){
            // +window.localStorage.civilizationId
            this.$http.get(this.datalink,{
                params:{
                    rows:10,
                    sortBy:'create_time',
                    desc:true,
                    page:page.num,
                    memberId:window.localStorage.civilizationId
                }
            })
            .then(resp=>{
                if(resp.data.success&&resp.data.data.items){
                    if (page.num === 1) {
                        this.dataLIst = [];
                    }
                    this.dataLIst=this.dataLIst.concat(resp.data.data.items);
                    this.$nextTick(()=>{
                        if(resp.data.data.items){
                            mescroll.endSuccess(resp.data.data.items.length);
                        }
                    })
                }else{
                    // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
                    mescroll.endErr()
                }
            }).catch(()=>{
                mescroll.endErr();
            })
        },

    }
}
</script>

<style scoped>
    .listUpDown{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .listContent{
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }
</style>